import React, { useEffect, useState,useCallback,useContext ,useMemo} from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import styles from './css/user.module.css';
import Swal from 'sweetalert2';
import Select from 'react-select';
import $ from 'jquery';
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/light.css";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import RefreshContext from './RefreshContext';
import {
  Box, 
   Button, 
  Select as MuiSelect,
  MenuItem, 
  Typography, 
  Tooltip, 
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  IconButton,
  Menu,Checkbox} from '@mui/material'; 
import { ArrowDropDown, ArrowDropUp, MoreVert as MoreVertIcon,DeleteOutline, EditOutlined, VisibilityOutlined, KeyboardArrowRight, FormatListBulleted } from '@mui/icons-material';
import apiurl from '../Api';

function VendorCopy({ embedOnly: embedOnlyProp = false, forceOpen = false, aidOverride = null, modalId = "exampleModal", addButtonId = "addStaffbtn" }) {
  const navigate = useNavigate();
  const location = useLocation();

  const [mainUrl,setMainURL]= useState("vendor.php");
  const vendorApiUrl = apiurl + "vendor.php";
  const categoryApiUrl = apiurl + "categoryadd.php";

  const [inputValue, setInput] = useState("");
  const [requirement, setRequirement] = useState(null);

  const { aid: aidParam } = useParams();
  const aid = aidOverride ?? aidParam;

  const [staff, setStaff] = useState([]);
  const [total, setTotal] = useState(0);

  const [selectedGender, setGender] = useState(null);
   const [selectSalu, setSalutation] = useState(null);
   const [selectCategory, setCategory] = useState(null);
   const [categoryParams, setCategoryParams] = useState([]);
   const [categoryLoading, setCategoryLoading] = useState(false);
   const [categoryName, setCategoryName] = useState("");
   const [categoryDescription, setCategoryDescription] = useState("");
   const [categoryRatio, setCategoryRatio] = useState("");
   const [categoryPostfix, setCategoryPostfix] = useState("");
   const [selectedServiceCategories, setSelectedServiceCategories] = useState([]);
  
   const [selectProfile, setProfile] = useState([]);
   const [selectLocation, setLocation] = useState([]);
    const [selectSkills, setSkill] = useState([]);
   const [selectEducation, setEducation] = useState([]);


   const [selectTax, setTax] = useState(null);
   const [selectGST, setGST] = useState(null);
   const [selectBG, setBG] = useState(null);
    const [selectBank, setBank] = useState(null);

    const [selectedStatus, setStatus] = useState(null);
  const [selectedCost, setCost] = useState(null);
  const [selectPlace, setPlacement] = useState(null);


  const [remark, setText] = useState("");
  const [loading, setTableLoading] = useState(true);

   const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(staff);
  const [currentStep, setCurrentStep] = useState(1);
  const [embedOnly, setEmbedOnly] = useState(false);

  const [isEditable, setIsEditable] = useState(true); // New state for editability
const [showButtons, setShowButtons] = useState(false);

const [showForm,setShowForm] = useState(false);  
const [error,setError]= useState("");
const [disabledApprove, setDisabledApprove] = useState(false);

const [disabledApprove2, setDisabledApprove2] = useState(false);

const [modifyMode, setModifyMode] = useState(false);
 const [stats,setStats]= useState([]);

  const [metaData, setMetaData] = useState({
    appname: '',
    edit: false,
    del: false,
    add: false,
    view: false,
    typess: '',
    icon: '',
    defaultShow: 10,
    okay:0,roll:0,
    bd:0
  });

    const [hiddenvalue, setHidden] = useState({
    type:0, hiddens :0, vendor:0
  });


  const GenderOptions = [
    { value: 'paid', label: 'PAID' },
    { value: 'unpaid', label: 'UNPAID' }
  ];
const saluationType = [ 
  { value: 'Mr.', label: 'Mr.' },
  { value: 'Mrs.', label: 'Mrs.' },
  { value: 'Ms.', label: 'Ms.' },
  { value: 'Dr.', label: 'Dr.' },
  { value: 'Prof.', label: 'Prof.' },
  { value: 'Mx.', label: 'Mx.' }
];

  const StatusOption = [
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' }
  ];

  const GSTOptions = [
    { value: 'registered', label: 'Registered' },
    { value: 'un-registered', label: 'Un-Registered' }
  ];

const TaxOptions = [
  { value: 'cgst_sgst', label: 'CGST & SGST' },
  { value: 'igst', label: 'IGST' },
  { value: 'sez', label: 'SEZ' },
  { value: 'exempt', label: 'EXEMPT' }
];


const BGoptions = [
   { value: 'yes', label: 'YES' },
    { value: 'no', label: 'NO' }
];

const BankOptions = [
  // Public Sector Banks
  { value: 'sbi', label: 'State Bank of India' },
  { value: 'bank_of_baroda', label: 'Bank of Baroda' },
  { value: 'punjab_national_bank', label: 'Punjab National Bank' },
  { value: 'canara_bank', label: 'Canara Bank' },
  { value: 'union_bank_of_india', label: 'Union Bank of India' },
  { value: 'bank_of_india', label: 'Bank of India' },
  { value: 'indian_bank', label: 'Indian Bank' },
  { value: 'central_bank_of_india', label: 'Central Bank of India' },
  { value: 'indian_overseas_bank', label: 'Indian Overseas Bank' },
  { value: 'uco_bank', label: 'UCO Bank' },
  { value: 'bank_of_maharashtra', label: 'Bank of Maharashtra' },
  { value: 'punjab_and_sind_bank', label: 'Punjab & Sind Bank' },

  // Private Sector Banks
  { value: 'hdfc_bank', label: 'HDFC Bank' },
  { value: 'icici_bank', label: 'ICICI Bank' },
  { value: 'axis_bank', label: 'Axis Bank' },
  { value: 'kotak_mahindra_bank', label: 'Kotak Mahindra Bank' },
  { value: 'indusind_bank', label: 'IndusInd Bank' },
  { value: 'yes_bank', label: 'YES Bank' },
  { value: 'idfc_first_bank', label: 'IDFC FIRST Bank' },
  { value: 'federal_bank', label: 'Federal Bank' },
  { value: 'south_indian_bank', label: 'South Indian Bank' },
  { value: 'karnataka_bank', label: 'Karnataka Bank' },
  { value: 'karur_vysya_bank', label: 'Karur Vysya Bank' },
  { value: 'jammu_and_kashmir_bank', label: 'Jammu & Kashmir Bank' },
  { value: 'csb_bank', label: 'CSB Bank' },
  { value: 'city_union_bank', label: 'City Union Bank' },
  { value: 'dcb_bank', label: 'DCB Bank' },
  { value: 'dhanlaxmi_bank', label: 'Dhanlaxmi Bank' },
  { value: 'nainital_bank', label: 'Nainital Bank' },
  { value: 'rbl_bank', label: 'RBL Bank' },
  { value: 'tamilnad_mercantile_bank', label: 'Tamilnad Mercantile Bank' },

  // Regional Rural Banks (RRBs)
  { value: 'andhra_pradesh_grameena_bank', label: 'Andhra Pradesh Grameena Bank' },
  { value: 'arunachal_pradesh_rural_bank', label: 'Arunachal Pradesh Rural Bank' },
  { value: 'assam_gramin_vikash_bank', label: 'Assam Gramin Vikash Bank' },
  { value: 'bihar_gramin_bank', label: 'Bihar Gramin Bank' },
  { value: 'chhattisgarh_rajya_gramin_bank', label: 'Chhattisgarh Rajya Gramin Bank' },
  { value: 'uttar_pradesh_gramin_bank', label: 'Uttar Pradesh Gramin Bank' },
  // ... you can continue adding other RRBs similarly
];


// vendor create
const ProfileType = [
  { value: 'commis_1', label: 'COMMIS 1' },
  { value: 'all', label: 'All' },
  { value: 'chef', label: 'CHEF' },
  { value: 'machine_operator', label: 'Machine Operator' },
  { value: 'purchase_executive', label: 'Purchase executive' },
  { value: 'technical_executive', label: 'Technical Executive' },
  { value: 'accountant', label: 'Accountant' },
  { value: 'receptionist', label: 'Receptionist' },
  { value: 'consumer_sales_officer', label: 'Consumer Sales Officer' },
  { value: 'sr_bde_bde', label: 'Sr.BDE / BDE' },
  { value: 'field_executive', label: 'Field Executive' }
];

const skillType = [
  { value: 'compliance_&_regulatory_knowledge', label: 'Compliance & Regulatory Knowledge' },
  { value: 'negotiation_skills', label: 'Negotiation Skills' },
  { value: 'contract_management', label: 'Contract Management' },
  { value: 'supply_chain_management', label: 'Supply Chain Management' },
  { value: 'financial_stability', label: 'Financial Stability' },
  { value: 'quality_control_&_assurance', label: 'Quality Control & Assurance' },
  { value: 'on_time_delivery', label: 'On-time Delivery' },
  { value: 'technical_expertise', label: 'Technical Expertise' },
  { value: 'customer_support', label: 'Customer Support' },
  { value: 'data_security_&_gdpr_compliance', label: 'Data Security & GDPR Compliance' },
  { value: 'innovation_&_process_improvement', label: 'Innovation & Process Improvement' },
  { value: 'sustainability_&_green_practices', label: 'Sustainability & Green Practices' },
  { value: 'health_&_safety_standards', label: 'Health & Safety Standards' },
  { value: 'communication_&_reporting', label: 'Communication & Reporting' },
  { value: 'ability_to_scale_services', label: 'Ability to Scale Services' }
];

const LocationType = [
  { value: 'mumbai', label: 'Mumbai' },
  { value: 'delhi', label: 'Delhi' },
  { value: 'bangalore', label: 'Bangalore' },
  { value: 'hyderabad', label: 'Hyderabad' },
  { value: 'chennai', label: 'Chennai' },
  { value: 'pune', label: 'Pune' },
  { value: 'ahmedabad', label: 'Ahmedabad' },
  { value: 'kolkata', label: 'Kolkata' },
  { value: 'jaipur', label: 'Jaipur' },
  { value: 'surat', label: 'Surat' },
  { value: 'lucknow', label: 'Lucknow' },
  { value: 'nagpur', label: 'Nagpur' },
  { value: 'indore', label: 'Indore' },
  { value: 'bhopal', label: 'Bhopal' },
  { value: 'patna', label: 'Patna' },
  { value: 'vadodara', label: 'Vadodara' },
  { value: 'rajkot', label: 'Rajkot' },
  { value: 'coimbatore', label: 'Coimbatore' },
  { value: 'ludhiana', label: 'Ludhiana' },
  { value: 'agra', label: 'Agra' },
];

const EducationType = [
  { value: 'ssc', label: 'SSC' },
  { value: 'hsc', label: 'HSC' },
  { value: 'diploma_it', label: 'Diploma in IT' },
  { value: 'diploma_mech', label: 'Diploma in Mechanical' },
  { value: 'diploma_civil', label: 'Diploma in Civil' },
  { value: 'bca', label: 'BCA' },
  { value: 'bba', label: 'BBA' },
  { value: 'bcom', label: 'B.Com' },
  { value: 'ba', label: 'B.A.' },
  { value: 'bsc', label: 'B.Sc' },
  { value: 'btech_it', label: 'B.Tech IT' },
  { value: 'btech_mech', label: 'B.Tech Mechanical' },
  { value: 'btech_civil', label: 'B.Tech Civil' },
  { value: 'btech_ece', label: 'B.Tech ECE' },
  { value: 'bpharm', label: 'B.Pharm' },
  { value: 'mbbs', label: 'MBBS' },
  { value: 'bds', label: 'BDS' },
  { value: 'barch', label: 'B.Arch' },
  { value: 'mba_hr', label: 'MBA HR' },
  { value: 'mba_finance', label: 'MBA Finance' },
  { value: 'mba_marketing', label: 'MBA Marketing' },
  { value: 'mca', label: 'MCA' },
  { value: 'mcom', label: 'M.Com' },
  { value: 'ma', label: 'M.A.' },
  { value: 'msc', label: 'M.Sc' },
  { value: 'mtech_it', label: 'M.Tech IT' },
  { value: 'mtech_mech', label: 'M.Tech Mechanical' },
  { value: 'mtech_civil', label: 'M.Tech Civil' },
  { value: 'mphil', label: 'M.Phil' },
  { value: 'phd', label: 'Ph.D' },
];

const CategoryType = [
  { value: 'primary_contact', label: 'Primary Contact' },
  { value: 'management', label: 'Management' },
  { value: 'reporting_manager', label: 'Reporting Manager/Approve Manager' },
  { value: 'finance', label: 'Finance' },
  { value: 'auditor', label: 'Auditor' },
  { value: 'compliance', label: 'Compliance' }
];

  const placementType = [
  { value: 'b_.voc', label: 'B.VOC' },
  { value: 'general_staffing', label: 'General Staffing' },
  { value: 'gig', label: 'GIG' },
  { value: 'it', label: 'IT' },
  { value: 'lep', label: 'LEP' },
  { value: 'neem', label: 'NEEM' },
  { value: 'naps', label: 'NAPS' },
  { value: 'naps_+_staffing', label: 'NAPS + STAFFING' },
  { value: 'neem_+_naps', label: 'NEEM + NAPS' },
  { value: 'neem_+_staffing', label: 'NEEM + STAFFING' },
  { value: 'staffing_+_staffing', label: 'STAFFING + STAFFING' },
  { value: 'naps-nats', label: 'NAPS-NATS' }
];

  const costCenterOptions = [
    { value: 'inara_training_and_skill_development_academy', label: 'Inara Training and Skill Development Academy' },
    { value: 'meraqi_ventures_and_private_limited', label: 'Meraqui Ventures Private Limited' },
    { value: 'vantagepoint_ventures', label: 'Vantagepoint Ventures Pvt Ltd' },
    { value: 'rav_pvt_ltd', label: 'RAV Pvt Ltd' }
  ];


 const paymentoptions = [
    { value: "FlatRate", label: "FlatRate" },
    { value: "Percentage", label: "Percentage" },
  ];

    const dynamicFilterOptions = useMemo(() => {
              const options = {};
              const selectAccessors = ['location','designation','exp','payroll_status_col','bank_status_col'];
              
              selectAccessors.forEach(key => {
                  const uniqueValues = new Set();
                  staff.forEach(row => {
                      if (row[key]) {
                          uniqueValues.add(row[key]);
                      }
                  });
                  options[key] = Array.from(uniqueValues).sort();
              });
              return options;
          }, [staff]);
      
  const [firstPayment, setFirstPayment] = useState(null);
  const [secondPayment, setSecondPayment] = useState(null);
  const [thirdPayment, setThirdPayment] = useState(null);
  const [fixedCost, setFixedCost] = useState(null);
  const [displayNot, setDisplayNot] = useState(true);
  const formId = useMemo(() => `vendor-submitform-${modalId}`, [modalId]);
const { refreshKey } = useContext(RefreshContext);
   
const [order, setOrder] = useState('asc'); 
const [orderBySelector, setOrderBySelector] = useState(() => (row) => row.rid); 
const [globalFilterText, setGlobalFilterText] = useState('');
const [columnFilters, setColumnFilters] = useState({});

const [currentPage, setCurrentPage] = useState(1);
const [totalRows, setTotalRows] = useState(0); // Set this from your API response
const limit = 50; 
const maxPage = Math.ceil(totalRows / limit);

  const fetchData = async (page) => {
    const response = await axios.get(vendorApiUrl+'?subdomain=react&aid='+aid+"&page="+page); // Replace with your API endpoint
    setStaff(response.data.staff || []);
    setStats(response.data.stats || []);
    setTotalRows(response.data.total_count || 0);
    
    setMetaData({
      appname: response.data.appname,
      edit: response.data.edit,
      del: response.data.del,
      add: response.data.add,
      view: response.data.view,
      typess: response.data.typess,
      icon: response.data.icon,
      defaultShow: response.data.defaultShow,
      bd:response.data.bd,
      roll : response.data.roll

    });
    setTotal(response.data.total);
    setTableLoading(false);
  };

  const fetchCategoryParams = async () => {
    try {
      setCategoryLoading(true);
      const response = await axios.get(categoryApiUrl + "?category_parameters=1");
      if (response.data.status === true) {
        setCategoryParams(response.data.data || []);
      } else {
        setCategoryParams([]);
      }
    } catch (error) {
      setCategoryParams([]);
    } finally {
      setCategoryLoading(false);
    }
  };

  const handleCategorySave = async () => {
    if (!categoryName.trim() || !categoryRatio.toString().trim()) {
      Swal.fire("Please fill Category and Sharing Ratio", "", "warning");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("category_action", "create");
      formData.append("category", categoryName.trim());
      formData.append("description", categoryDescription.trim());
      formData.append("sharing_ratio", categoryRatio);
      formData.append("sharing_postfix", categoryPostfix.trim());
      const response = await axios.post(categoryApiUrl, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.data.status === true) {
        setCategoryName("");
        setCategoryDescription("");
        setCategoryRatio("");
        setCategoryPostfix("");
        fetchCategoryParams();
        Swal.fire("Category Added", "", "success");
      } else {
        Swal.fire(response.data.message || "Error", "", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Server Error", "error");
    }
  };

  const handleCategoryDelete = async (id) => {
    if (!id) return;
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This category will be deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
    });
    if (!result.isConfirmed) return;
    try {
      const formData = new FormData();
      formData.append("category_action", "delete");
      formData.append("id", id);
      const response = await axios.post(categoryApiUrl, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.data.status === true) {
        fetchCategoryParams();
        Swal.fire("Deleted", "", "success");
      } else {
        Swal.fire(response.data.message || "Error", "", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Server Error", "error");
    }
  };

  // form submit in category
  const FormSubmit = async (e) => {
    e.preventDefault();
    if (!validateStep(currentStep)) {
      Swal.fire("Please fill required fields!", "", "warning");
      return;
    }
    if (currentStep === 3) {
      if (!selectLocation.length || !selectEducation.length || !selectSkills.length) {
        Swal.fire("Please select Location, Education, and Skills", "", "warning");
        return;
      }
    }
    // try and catch method
    try {
      const formEl = document.getElementById(formId);
      if (!formEl) {
        Swal.fire("Form not found", "", "error");
        return;
      }
      const formData = new FormData(formEl);

      if (!selectedServiceCategories || selectedServiceCategories.length === 0) {
        Swal.fire("Please select at least 1 category", "", "warning");
        return;
      }

      const payload = {
        category: selectedGender,
        businessType: selectPlace,
        Categorytypes: selectCategory, status:selectedStatus,
        salutation: selectSalu,
        costCenter: selectedCost,
        profile:selectProfile,
        skill:selectSkills,
        education:selectEducation,
        location:selectLocation,
        taxType:selectTax,
        bgvVendor:selectBG,
        gstType:selectGST,
        service_categories: JSON.stringify(selectedServiceCategories),
      };

      Object.entries(payload).forEach(([key, value]) => {
        formData.append(key, value || "");
      });

      setLoading(true);
       
       const response = await axios.post(vendorApiUrl, formData);

      if (response.data.status == true) {
        setLoading(false);
        Swal.fire({
          position: "top-center",
          icon: "success",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          $(`#${modalId} .btn-close`).click();
          setCurrentPage(1);
          fetchData();
        });
      }
      else {
        setLoading(false);
        Swal.fire({
          position: "top-center",
          icon: "error",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
      }
    } catch (error) {
      console.log("bhai error", error.response?.data?.message); // Handle errors with informative messages
    }
    finally {
      setLoading(false);
    }
  };
  
  const DeleteData = async (id) => {
    if (!id) { return false; }
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this data!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.get(vendorApiUrl + "?del=" + id);
        if (response.data.status == true) {
          Swal.fire({
            position: "top-center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 2000
          }).then(() => {
            fetchData();
          });

        }
        else {
          console.log(response.data.message);
        }
      }
      catch (error) {
        console.error('Error deleting category:', error);
      }


    };

  };

const EditData = async (edit, sss) => {
    if (edit) {
      $("#showLoader").removeClass('d-none').addClass('d-flex');
      try {
        setCurrentStep(1);
        const response = await axios.get(vendorApiUrl+'?edit=' + edit);
        if (response.data.status == true) {
            
        const data = response.data.data[0];
        
        if(sss=="1"){
        for (const key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
             const value = (data[key] ?? "").toString().trim();
              $(`#submitform [name="${key}"]`).val(value);
            }
          }

            setGender(data.vendorcategory || "");
            setStatus(data.statuss || "");
            setPlacement(data.placementType || "");
            setCost(data.costCenter || "");
            setSalutation(data.salu || "");
            setCategory(data.category || "");

            setProfile(data.profile && data.profile.trim() !== "" ? data.profile : [] );
            setEducation(data.education && data.education.trim() !== "" ? data.education : [] );
            setSkill(data.skill && data.skill.trim() !== "" ? data.skill : [] );
            setLocation(data.location && data.location.trim() !== "" ? data.location : [] );

            setTax(data.tax || "");
            setBG(data.mark || "");
            setGST(data.gst || "");
            try {
              const parsedCategories = JSON.parse(data.service_categories || "[]");
              setSelectedServiceCategories(Array.isArray(parsedCategories) ? parsedCategories : []);
            } catch (e) {
              setSelectedServiceCategories([]);
            }
              $(`#${addButtonId}`).click();
        }
        
        else {
        setRequirement(data);
        $("#tera_modal3").click();
        }

          
           $("#showLoader").removeClass('d-flex').addClass('d-none');
        
        } else {
          // modal can't show
          $("#showLoader").removeClass('d-flex').addClass('d-none');
          alert("data not found");
        }

      }
      catch (error) {
        console.error('Error deleting category:', error);
      }

    }

  };

const handleReset = (form) => {
   document.querySelector(form+" form").reset();

            setGender(null);
            setStatus(null);
            setPlacement(null);
            setCost(null);
            setSalutation(null);
            setCategory(null);
            setProfile([]);
             setEducation([] );
            setSkill([] );
            setLocation( [] );
            setTax(null);
            setBG(null);
            setGST(null);
            setSelectedServiceCategories([]);

   $(form+" #hiddenss").val("");
};

useEffect(() => {
 
}, [isEditable, showButtons, showForm]);


const updateDetails = async (idd, val) => {
    setLoading(true);
      
    try{
      const response = await axios.get(apiurl + 'vendor_data.php?com=' + idd + "&value=" + val);
   
      setFixedCost(response.data.value4 || "");
      setDisplayNot(true);
      setError('');
      setDisabledApprove(false);
      setDisabledApprove2(false);
      setFirstPayment(response.data.value1 || "");
      setSecondPayment(response.data.value2 || "");
      setThirdPayment(response.data.value3 || "");
      setHidden({type:val,hiddens:response.data.hidden,vendor:response.data.vendor});
   
      $("#showornot").show();
      
      if(val === 1 || val === 2){
         $("#queryMessage").hide();
         setShowForm(1);
         setShowButtons(val === 2);
         if(val ===2){
         setIsEditable(false);
         }
         else{
          setIsEditable(true);
         }
         setText("Payment Details");
      }
      else{
           setText("Update Status");
           setIsEditable(false);
           $("#queryMessage").show();
           setShowForm(2);
      }
      
      $("#tera_modal").click();
      setTimeout(() => {
  $("input[name='firstamount']").val(response.data.value5);
  $("input[name='secondamount']").val(response.data.value6);
  $("input[name='thirdamount']").val(response.data.value7);
  $("input[name='fixedamount']").val(response.data.value8);
  $("input[name='recru']").val(response.data.value10);
  $("input[name='mark']").prop("checked", response.data.value9 === "yes");
      }, 300);
      setLoading(false);
   
    }
    catch{
      console.log("Error");
    }
    finally{
      setLoading(false);
    }

 };

  const setLoading = (show) => {
    if (show) {
      $("#showLoader").removeClass("d-none").addClass("d-flex");
    } else {
      $("#showLoader").removeClass("d-flex").addClass("d-none");
    }
  };


  const UpdateForm = async (e) => {
    e.preventDefault();
    const formData = new FormData($("#updateForm")[0]);
    const buttonValue = e.target.value; 
    formData.append("change",buttonValue);
    
    if(buttonValue=="reject" || buttonValue=='011'){
        setDisabledApprove(false);
        setDisabledApprove2(true);
        setDisplayNot(false);
          if(!inputValue.trim()){
             setError('Remark is required when rejecting.');
   Swal.fire({
  title: "Remark is required when rejecting.",
  text: "",
  icon: "error"
});
             return false;
          }
       
    }

  if (buttonValue === "111") {
    if (!modifyMode) {
      setIsEditable(true);
      setDisabledApprove(true);
       setDisabledApprove2(false);
      setModifyMode(true); // now in modify mode
      return; // don't submit yet
    } else {
      setModifyMode(false); // reset for future
    }
  }
  
    setError('');
    try {

if (buttonValue === "accept" || buttonValue === "reject") {
  formData.append("two_comment", inputValue);
} else {
  formData.append("comment", firstPayment);
  formData.append("comment2", secondPayment);
  formData.append("comment3", thirdPayment);
  formData.append("comment4", fixedCost);
  formData.append("rejectremark",inputValue);
}

      setLoading(true);
      const response = await axios.post(apiurl + "vendor_data.php", formData);
        Swal.fire({
          position: "top-center",
          icon: response.data.status,
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          if(response.data.status=="success"){
           $(".modal .btn-close").click();
           fetchData();
          }
        });
     
    } catch (error) {
      console.log("bhai error", error.response?.data?.message); // Handle errors with informative messages
    }
    finally {
      setLoading(false);
    }
  };

const displayCount = 5;
let startPage = Math.max(1, currentPage - Math.floor(displayCount / 2));
let endPage = startPage + displayCount - 1;

if (endPage > maxPage) {
    endPage = maxPage;
    startPage = Math.max(1, endPage - displayCount + 1);
}

const pages = [];
for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
}


useEffect(() => {
  fetchData(currentPage); // Only fetch on mount
  fetchCategoryParams();
  document.title = "Create Vendor | MERAQUI";
}, [aid,refreshKey,currentPage]);

useEffect(() => {
  const params = new URLSearchParams(location.search);
  const isEmbed = embedOnlyProp || params.get("open") === "add";
  setEmbedOnly(isEmbed);
  if (!embedOnlyProp) {
    document.body.classList.toggle("embed-vendor-only", params.get("open") === "add");
  } else {
    document.body.classList.remove("embed-vendor-only");
  }
  if (forceOpen || params.get("open") === "add") {
    setTimeout(() => {
      const btn = document.getElementById(addButtonId);
      if (btn) btn.click();
    }, 100);
  }
  return () => {
    document.body.classList.remove("embed-vendor-only");
  };
}, [location.search]);

useEffect(() => {
  const form = document.getElementById(formId);
  if (!form) return;

  const handleInput = (e) => {
    const target = e.target;
    if (!target || typeof target.getAttribute !== "function") return;
    if (!target.getAttribute("required")) return;
    if (target.value && target.value.trim()) {
      const next = target.nextElementSibling;
      if (next && (next.classList.contains("error-text") || next.textContent === "Empty")) {
        next.remove();
      }
    }
  };

  form.addEventListener("input", handleInput);
  form.addEventListener("change", handleInput);
  return () => {
    form.removeEventListener("input", handleInput);
    form.removeEventListener("change", handleInput);
  };
}, [formId]);

const totalSteps = (selectedGender === 'paid') ? 4 : 3;
const activeCategoryParams = categoryParams.filter(
  (item) => Number(item.is_active) === 1
);
const categoryOptions = activeCategoryParams.map((item) => ({
  value: item.id,
  label: `${item.category} (${item.sharing_ratio}${item.sharing_postfix ? ` ${item.sharing_postfix}` : ""})`,
}));
const selectedCategoryOptions = categoryOptions.filter((opt) =>
  selectedServiceCategories.includes(opt.value) ||
  selectedServiceCategories.includes(String(opt.value))
);

const validateStep = (stepNumber) => {
    let valid = true;
    const formEl = document.getElementById(formId);
    if (!formEl) return false;
    const requiredFields = formEl.querySelectorAll(
      `.form-step[data-step="${stepNumber}"] [required]`
    );

    requiredFields.forEach((input) => {
        const errorSpan = input.nextElementSibling;
        if (errorSpan && (errorSpan.classList.contains("error-text") || errorSpan.textContent === "Empty")) {
            errorSpan.remove();
        }
        if (!input.value.trim()) {
            valid = false;
            const span = document.createElement("span");
            span.className = "error-text";
            span.textContent = "Empty";
            span.style.color = "red";
            span.style.fontSize = "12px";
            span.style.lineHeight = "1";
            span.style.paddingLeft = '4px';
            input.insertAdjacentElement("afterend", span);
        }
    });

    if (stepNumber === 1) {
        if (!selectedGender) {
            valid = false;
            const label = document.querySelector('label[htmlFor="vendor_category"]');
            if (label) {
                label.style.color = 'red';
            }
        }
        if (!selectedStatus) {
            valid = false;
            const label = document.querySelector('label[htmlFor="status"]');
            if (label) {
                label.style.color = 'red';
            }
        }
    }
    return valid;
};

const handleNext = () => {
    if (!validateStep(currentStep)) {
        Swal.fire("Please fill required fields!", "", "warning");
        return;
    }
    if (currentStep < totalSteps) {
        setCurrentStep(currentStep + 1);
    }
};

const handlePrev = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
};

const getComparator = (order, orderBy) => {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
};

const descendingComparator = (a, b, orderBy) => {
    const valA = orderBy(a);
    const valB = orderBy(b);

    if (valB < valA) {
        return -1;
    }
    if (valB > valA) {
        return 1;
    }
    return 0;
};


const ColumnHeaderWithFilter = ({ 
    column, 
    orderBySelector, 
    order, 
    handleRequestSort, 
    columnFilters, 
    setColumnFilters,
    
}) => {
   const [localOpenKey, setLocalOpenKey] = useState(null);
   const [anchorEl, setAnchorEl] = useState(null);
    const accessorKey = column.accessorKey;
   
   const isMenuOpen = localOpenKey === accessorKey; // <--- NEW WAY
    const currentFilter = String(columnFilters[accessorKey] || ''); 
    const isSorted = orderBySelector === column.selector;

    const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setLocalOpenKey(accessorKey);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setLocalOpenKey(null);
    };

    const handleFilterChange = (e) => {
        setColumnFilters(prev => ({
            ...prev,
            [accessorKey]: e.target.value
        }));
    };
    
    const isSortable = !!column.selector;
    const isFilterable = !!column.filterType;


    // --- Custom Filter Input Renderer ---
    const renderFilterInput = () => {
        if (column.filterType === 'select') {
            // Use the dynamically derived filterOptions attached to the column object
            const filterOptions = column.dynamicFilterOptions || [];
            
            return (
                <MuiSelect
                    label={`Filter ${column.header}`}
                    variant="outlined"
                    size="small"
                    value={currentFilter}
                    onChange={handleFilterChange}
                    sx={{ width: '100%' }}
                >
                    {/* Default option to show all values */}
                    <MenuItem value="">— All —</MenuItem>
                    {filterOptions.map(option => (
                        <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                </MuiSelect>
            );
        }

        if (column.filterType === 'date') {
            return (
                <TextField
                    label={`Filter ${column.header}`}
                    type="date" 
                    variant="outlined"
                    size="small"
                    value={currentFilter}
                    onChange={handleFilterChange}
                    // This ensures the label is correctly positioned for date input
                    InputLabelProps={{ shrink: true }} 
                    sx={{ width: '100%' }}
                />
            );
        }

        // Default: text filter
        return (
            <TextField
                label={`Filter ${column.header}`}
                variant="outlined"
                size="small"
                value={currentFilter}
                onChange={handleFilterChange}
                autoFocus
                sx={{ width: '100%' }}
            />
        );
    };


    return (
        <Box 
            sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between', 
                width: '100%', 
                '& .MuiTableSortLabel-root': { flexGrow: 1 } 
            }}
        >
            <TableSortLabel
                active={isSorted}
                direction={isSorted ? order : 'asc'}
                onClick={() => isSortable && handleRequestSort(column.selector)}
                IconComponent={isSorted ? (order === 'desc' ? ArrowDropDown : ArrowDropUp) : undefined}
                sx={{ 
                    cursor: isSortable ? 'pointer' : 'default',
                    '&.Mui-active': {
                        color: 'primary.main',
                        fontWeight: 'bold',
                    }
                }}
            >
                {column.header}
            </TableSortLabel>

            {isFilterable && (
                <>
                    <IconButton
                        aria-label="filter"
                        size="small"
                        onClick={handleClick}
                        sx={{ 
                            ml: 1, 
                            p: 0,
                            color: currentFilter ? 'primary.main' : 'text.secondary',
                        }}
                    >
                        <MoreVertIcon fontSize="inherit" />
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        open={isMenuOpen}
                        onClose={handleClose}
                        onClick={(e) => e.stopPropagation()} 
                        PaperProps={{
                            sx: { width: 250, p: 1, boxShadow: 6, borderRadius: 2 }
                        }}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    >
                        <Box sx={{ width: '100%', p: 1 }}>
                            {renderFilterInput()}
                        </Box>
                        
                        {/* Clear filter button */}
                        {currentFilter && (
                             <Button
                                onClick={() => {
                                    setColumnFilters(prev => ({ ...prev, [accessorKey]: '' }));
                                    handleClose();
                                }}
                                size="small"
                                color="error"
                                sx={{ mt: 1, textTransform: 'none' }}
                            >
                                Clear Filter
                            </Button>
                        )}
                    </Menu>
                </>
            )}
        </Box>
    );
};

const columns = useMemo(() => {
        let baseColumns = [
              { accessorKey: 'vid', header: 'Vendor ID', size: 150, selector: (row) => row.vendorid, filterType: 'text' },
            { accessorKey: 'recname', header: 'REC Name', size: 150, selector: (row) => row.recname, filterType: 'text' },
            { 
                accessorKey: 'name', 
                header: 'Vendor Name', 
                size: 150, 
                selector: (row) => row.name, 
                filterType: 'text'
            },
            { 
                accessorKey: 'category', 
                header: 'Vendor Category', 
                size: 150, 
                selector: (row) => row.vendor_category, 
                filterType: 'select',
                dynamicFilterOptions: dynamicFilterOptions['category']
            },
            { 
                accessorKey: 'saluation', 
                header: 'Saluation', 
                size: 150, 
                selector: (row) => row.saluation, 
            },
            { 
                accessorKey: 'city', 
                header: 'City', 
                size: 150, 
                selector: (row) => row.city, 
                filterType: 'select',
                dynamicFilterOptions: dynamicFilterOptions['city']
            },

        ];
    
    const bd = String(metaData.bd);
    const typeUpper = metaData.typess?.toUpperCase();
    
    const showSMStatus = ["1", "4", "5"].includes(bd) || (bd === "4" && typeUpper === 'VENDOR');
    const showVendorStatus = ["1", "2", "5"].includes(bd);
    const showFounderStatus = ["1", "2"].includes(bd) || (bd === "4" && typeUpper === 'VENDOR');
   
    if (showSMStatus) {
        baseColumns.push({ 
            accessorKey: 'sm_status_col', 
            header: 'SM Status', 
            size: 150, 
            isStatusColumn: true // Custom prop for identification
        });
    }

    if (showVendorStatus) {
        baseColumns.push({ 
            accessorKey: 'vendor_status_col', 
            header: 'Vendor Status', 
            size: 150,
            isStatusColumn: true
        });
    }

    if (showFounderStatus) {
        baseColumns.push({ 
            accessorKey: 'founder_status_col', 
            header: 'Founder Status', 
            size: 150,
            isStatusColumn: true
        });
    }
    
    if (["2", "4", "5"].includes(bd)) {
        baseColumns.push({
            accessorKey: 'action_payment_terms', // New accessorKey for the complex action column
            header: 'Action',
            size: 180,
            isActionButton: true
        });
    }

    return baseColumns;
}, [dynamicFilterOptions, metaData.bd, metaData.typess]);

    const handleRequestSort = useCallback((selector) => {
        const isAsc = orderBySelector === selector && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBySelector(() => selector);
    }, [order, orderBySelector]);


  const processedData = useMemo(() => {
        let filtered = staff;
        const lowerCaseFilter = globalFilterText.toLowerCase();

        // 1. Apply Global Filter
        if (lowerCaseFilter) {
            filtered = filtered.filter(row => 
                columns.some(column => {
                    const value = column.selector ? String(column.selector(row)) : '';
                    return value.toLowerCase().includes(lowerCaseFilter);
                })
            );
        }

        // 2. Apply Column Filters
        filtered = filtered.filter(row => {
            return columns.every(column => {
                const accessorKey = column.accessorKey;
                const filterValue = columnFilters[accessorKey];

                if (!filterValue) return true;
                if (!column.selector) return true;

                const rowValue = String(column.selector(row));

                switch (column.filterType) {
                    case 'select':
                        // Must match the selected value exactly
                        return rowValue === filterValue; 
                        
                    case 'date':
                        // Check if the date string (e.g., '2024-01-15') includes the filter date
                        return rowValue.includes(filterValue); 
                        
                    case 'text':
                    default:
                        return rowValue.toLowerCase().includes(filterValue.toLowerCase());
                }
            });
        });

        // 3. Sorting Logic
        const sortColumn = columns.find(col => col.selector === orderBySelector);

        if (sortColumn) {
            return stableSort(filtered, getComparator(order, sortColumn.selector));
        }
        
        return filtered;

    }, [staff, columns, order, orderBySelector, globalFilterText, columnFilters]);


const RenderReqIdCell = useCallback(({ row }) => {
    const rowData = row;
     const isViewDetailClickable = true; // Set to true or use metaData.view check if needed
    
    let statsColor = ''; let idTooltipContent = '';
    if (rowData.statues.toLowerCase() === 'success') {
       statsColor = '#10B981'; idTooltipContent = 'Vendor Approved';
    }
    else{
       statsColor = '#F59E0B'; idTooltipContent='Vendor In-process';
    }
 return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, whiteSpace: 'nowrap' ,width:150}}>

           <Tooltip title={isViewDetailClickable ? 'View Detail' : ''} arrow>
                <IconButton
                    size="small"
                    onClick={() => EditData(rowData.hidden, "2")} 
                    sx={{
                        color: 'orange', 
                        p: 0.5,
                        '&:hover': {
                            color: isViewDetailClickable ? '#0056b3' : 'text.disabled',
                            backgroundColor: 'transparent'
                        }
                    }}
                >
                    <VisibilityOutlined sx={{ fontSize: '1rem' }} />
                </IconButton>
            </Tooltip>
            
             <Tooltip title={idTooltipContent} arrow>
                <Button
                    sx={{
                        background: "none",
                        border: "none",
                        color: statsColor, // Use status color for the ID text
                         padding: 0,
                        minWidth: 0, 
                        fontWeight: 500,
                        textAlign: 'left',
                        textTransform: 'none',
                        fontSize: '0.875rem',
                        '&:hover': { backgroundColor: 'transparent' }
                    }}
                >
                    {rowData.vendorid}
                </Button>
            </Tooltip>
            
        </Box>
    );
}, [navigate, EditData]);


  return (
    <>
      <button data-bs-toggle="modal" id="tera_modal" data-bs-target="#allModal" type="button" style={{ display: 'none' }}></button>
      <button data-bs-toggle="modal" id="tera_modal2" data-bs-target="#sourceModal" type="button" style={{ display: 'none' }}></button>
      <button data-bs-toggle="modal" id="tera_modal3" data-bs-target="#tableModal" type="button" style={{ display: 'none' }}></button>

      <div className="modal effect-flip-horizontal fade" id="allModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="allModal" aria-hidden="true">
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title" id="allModalu">{remark}</h6>
              <button type="button" className="btn-close" data-bs-dismiss="modal" id="okayClose" aria-label="Close"></button>
            </div>
         {(showForm === 1 || showForm === 2) && (
            <form id="updateForm">
              
              <div className="modal-body" style={{paddingBottom:'0px'}}>

                <div className="row g-3">
                  <div className="col-lg-12" id='queryMessage' style={{ textAlign: 'center' }}>
                     <h6>Approve or Reject the Query</h6>
                  </div>
              
      {/* 1st Payroll */}
      <div className="col-xl-6 col-lg-6 col-md-6">
        <label className="form-label">1ST PAYROLL MONTH PAYMENT</label>
        <Select
          options={paymentoptions}
          value={paymentoptions.find(opt => opt.value === firstPayment) || null}
          onChange={option => setFirstPayment(option ? option.value : null)}
          placeholder="Select"  isDisabled={!isEditable}
        />
      </div>

      <div className="col-xl-6 col-lg-6 col-md-6">
        <label className="form-label">FIRST PAYROLL {firstPayment=='FlatRate' ? 'Amount' : 'Percentage'}</label>
        <input
          type="text"
          className="form-control"
          placeholder="Enter 1st Payroll" name='firstamount' readOnly={!isEditable}
        />
      </div>

      {/* 2nd Payroll */}
      <div className="col-xl-6 col-lg-6 col-md-6">
        <label className="form-label">2ND PAYROLL MONTH PAYMENT</label>
        <Select
          options={paymentoptions}
          value={paymentoptions.find(opt => opt.value === secondPayment) || null}
          onChange={option => setSecondPayment(option ? option.value : null)}
          placeholder="Select" isDisabled={!isEditable}
        />
      </div>

      <div className="col-xl-6 col-lg-6 col-md-6">
        <label className="form-label">SECOND PAYROLL {secondPayment=='FlatRate' ? 'Amount' : 'Percentage'}</label>
        <input
          type="text"
          className="form-control"
          placeholder="Enter 2nd Payroll"  name='secondamount'readOnly={!isEditable}
        />
      </div>

      {/* 3rd Payroll */}
      <div className="col-xl-6 col-lg-6 col-md-6">
        <label className="form-label">3RD PAYROLL MONTH PAYMENT</label>
        <Select
          options={paymentoptions}
          value={paymentoptions.find(opt => opt.value === thirdPayment) || null}
          onChange={option => setThirdPayment(option ? option.value : null)}
          placeholder="Select" isDisabled={!isEditable}
        />
      </div>

      <div className="col-xl-6 col-lg-6 col-md-6">
        <label className="form-label">THIRD PAYROLL {thirdPayment=='FlatRate' ? 'Amount' : 'Percentage'}</label>
        <input
          type="text"
          className="form-control"
          placeholder="Enter 3rd Payroll"  name='thirdamount' readOnly={!isEditable}
        />
      </div>

      {/* Fixed Cost */}
      <div className="col-xl-6 col-lg-6 col-md-6">
        <label className="form-label">FIXED COST AGREED</label>
        <Select
          options={paymentoptions}
          value={paymentoptions.find(opt => opt.value === fixedCost) || null}
          onChange={option => setFixedCost(option ? option.value : null)}
          placeholder="Select" isDisabled={!isEditable}
        />
      </div>

      <div className="col-xl-6 col-lg-6 col-md-6">
        <label className="form-label">FIXED {fixedCost=='FlatRate' ? 'Amount' : 'Percentage'}</label>
        <input
          type="text"
          className="form-control"
          placeholder="Enter Fixed"  name='fixedamount' readOnly={!isEditable}
        />
      </div>

      <div className="col-xl-3 col-lg-3 col-md-3 d-flex align-items-end">
        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id="mark"  name='mark' value='yes' isDisabled={!isEditable}
          />
          <label className="form-check-label" htmlFor="mark">
            Mark
          </label>
        </div>
      </div>
       {/* Recurring & Checkbox */}
      <div className="col-xl-6 col-lg-6 col-md-9">
        <label className="form-label">RECURRING AMOUNT</label>
        <input
          type="text"
          className="form-control"
          placeholder="Enter Recurring Amount" name='recru' readOnly={!isEditable}
        />
      </div>
                 
                  
                  <div className="col-lg-12" style={{ textAlign: 'right' }}>
                    <input type="hidden" name="hidden" id="hiddens" value={hiddenvalue.hiddens}/>
                    <input type="hidden" name="vendor" id="vendor"  value={hiddenvalue.vendor}/>
                    <input type="hidden" name="type" id="type"  value={hiddenvalue.type} />
                    <input type="reset" name="reset" id="reset" className="btn btn-danger" style={{ marginRight: '20px', display: 'none' }} />
                  </div>
                </div>

                <div className='row g-3' style={{display:(displayNot ? 'none' : 'block')}}>
                  <div className='col-12'>
                     <label className="form-label">Reject Remark</label>
                    <textarea onChange={(e) => setInput(e.target.value)} value={inputValue} className='form-control'></textarea>
                </div>
                  {(error!='') && (  <span className='text-danger'>{error}</span>)}
                </div>

              </div>

{showForm === 1 ? (
  <>
    {!showButtons ? (
      <div className='modal-footer' id='showornot' style={{ padding: '0px', borderTop: '0px' }}>
        <button type="button" className="btn btn-primary" value="1" onClick={UpdateForm}>Submit</button>
      </div>
    ) : (
      <div className='modal-footer d-flex' style={{ padding: '0px', borderTop: '0px' }}>
        <button type="button" className="btn btn-success" value="01"  disabled={disabledApprove || disabledApprove2} onClick={UpdateForm}>Accept</button>
        <button type="button" className="btn btn-danger" value="011"  disabled={disabledApprove} onClick={UpdateForm}>Reject</button>
        <button type="button" className="btn btn-warning" value="111" disabled={disabledApprove2} onClick={UpdateForm}>{modifyMode ? "UPDATE" : "Modify"}</button>
      </div>
    )}
  </>
) : showForm === 2 ? (
  <div className='modal-footer' style={{ textAlign:'center',padding: '0px', borderTop: '0px' }}>
    <button type="button" className="btn btn-success" value="accept" disabled={disabledApprove} onClick={UpdateForm}>Accept</button>
    <button type="button" className="btn btn-danger" value="reject" onClick={UpdateForm}>Reject</button>
  </div>
) : null}
          
            </form>
       )}
          
          </div>
        </div>
      </div>

      <div className="modal effect-super-scaled fade" id="tableModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="tableModal" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className='modal-header'>
               <h6 className="modal-title">Vendor All Details</h6>
          </div>
          <div className="modal-content">
            <div className="modal-body">
              <div className='d-flex' style={{gap:'20px',alignItems:'start'}}>


                <table className="table table-bordered" >
                  <tbody>
{requirement && [
    ["Vendor Name", requirement.vendor_name, "Vendor Type", requirement.vtype, "Lead", requirement.lead],
    ["Manager", requirement.manager, "State", requirement.state, "City", requirement.city],
    ["Address", requirement.address, "Pincode", requirement.pincode, "First Name", requirement.firstname],
    ["Last Name", requirement.lastname, "Email", requirement.email, "Mobile", requirement.mobile],
    ["Location", requirement.location, "Education", requirement.education, "Skills", requirement.skill],
    ["Profile", requirement.profile, "GST No.", requirement.gstNo, "PAN No.", requirement.panNo],
    ["Invoice Country", requirement.invoiceCountry, "Invoice State", requirement.invoiceState, "Service Tax No.", requirement.serviceTaxNo],
    ["TAN No.", requirement.tanNo, "Ship To Name", requirement.shipToName, "Ship To Address", requirement.shipToAddress],
    ["Ship To Pincode", requirement.shipToPincode, "Ship To GST No.", requirement.shipToGstNo, "Sales Anchor", requirement.salesAnchor],
    ["Placement Type", requirement.placementType, "Vendor Category", requirement.vendorcategory, "Status", requirement.statuss],
    ["Cost Center", requirement.costCenter, "Salutation", requirement.salu, "Category Type", requirement.category],
    ["Tax Type", requirement.tax, "GST Type", requirement.gst, "BGV Vendor", requirement.mark]
].map((row, idx) => (
                      <tr key={idx}>
                        <th style={{ backgroundColor: "#fafafa" ,padding:'7px 10px'}}>{row[0]}</th>
                        <td style={{padding:'7px 10px'}}>{row[1]}</td>
                        <th style={{ backgroundColor: "#fafafa" ,padding:'7px 10px'}}>{row[2]}</th>
                        <td style={{padding:'7px 10px'}}>{row[3]}</td>
                      </tr>
                    ))}

 {requirement && (
  <tr>
    <th style={{ backgroundColor: "#fafafa", padding: "7px 10px" }}>Payment Terms</th>
    <td
      colSpan="3"
      style={{ padding: "7px 10px" }}
      dangerouslySetInnerHTML={{ __html: requirement.payment || "" }}
    />
  </tr>
)}
             
                  </tbody>
                </table>


                <img className="order-1" src={process.env.PUBLIC_URL + "/images/media/personal.svg"} style={{ width: '28%' }} />


              </div>
            </div>
            <div className='modal-footer' style={{ padding: '0px' }}>
              <button type="button" className="btn btn-danger btn-sm" data-bs-dismiss="modal" id="okayClose" aria-label="Close">Close</button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal effect-flip-vertical fade" id="sourceModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="sourceModal" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title" id="sourceModal">Select Source Head</h6>
              <button type="button" className="btn-close" data-bs-dismiss="modal" id="okayClose2" aria-label="Close"></button>
            </div>

            <div className='d-flex'>
           

              <img className="order-2" src={process.env.PUBLIC_URL + "/admin_assets/images/media/media-69.svg"} style={{ width: '35%', height: '100%' }} />
            </div>

          </div>
        </div>
      </div>

      <div className="modal fade" id="categoryModal" tabIndex="-1" data-bs-backdrop="static" aria-hidden="true">
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Add Category</h6>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="row g-3 mb-3">
                <div className="col-md-6">
                  <label className="form-label">Category<span className="text-danger">*</span></label>
                  <input
                    type="text"
                    className="form-control"
                    value={categoryName}
                    onChange={(e) => setCategoryName(e.target.value)}
                    placeholder="Category name"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Sharing Ratio (%)<span className="text-danger">*</span></label>
                  <input
                    type="number"
                    className="form-control"
                    value={categoryRatio}
                    onChange={(e) => setCategoryRatio(e.target.value)}
                    placeholder="e.g. 50"
                  />
                </div>
                <div className="col-md-8">
                  <label className="form-label">Description</label>
                  <input
                    type="text"
                    className="form-control"
                    value={categoryDescription}
                    onChange={(e) => setCategoryDescription(e.target.value)}
                    placeholder="Short description"
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label">Sharing Ratio Postfix</label>
                  <input
                    type="text"
                    className="form-control"
                    value={categoryPostfix}
                    onChange={(e) => setCategoryPostfix(e.target.value)}
                    placeholder="e.g. BA Share"
                  />
                </div>
              </div>

              <div className="d-flex justify-content-end mb-3">
                <button className="btn btn-primary" onClick={handleCategorySave}>
                  Save Category
                </button>
              </div>

              <div className="table-responsive">
                <table className="table table-bordered align-middle mb-0">
                  <thead>
                    <tr>
                      <th>Category</th>
                      <th>Description</th>
                      <th>Sharing Ratio</th>
                      <th style={{ width: "90px" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {categoryLoading ? (
                      <tr>
                        <td colSpan="4" className="text-center text-muted py-3">Loading...</td>
                      </tr>
                    ) : categoryParams.length > 0 ? (
                      categoryParams.map((item) => (
                        <tr key={item.id}>
                          <td>{item.category}</td>
                          <td>{item.description || "-"}</td>
                          <td>
                            {item.sharing_ratio}
                            {item.sharing_postfix ? ` ${item.sharing_postfix}` : ""}
                          </td>
                          <td>
                            <button
                              className="btn btn-outline-danger btn-sm"
                              onClick={() => handleCategoryDelete(item.id)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center text-muted py-3">No categories found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

      <div className="offcanvas offcanvas-top" style={{ maxHeight: '100%', height: 'auto', backgroundColor: 'rgb(245 245 245)' }} tabIndex="-1" id={modalId} >
        <div className="offcanvas-header border-bottom border-block-end-dashed">
          <h5 className="offcanvas-title" id="offcanvasRightLabel1">{metaData.appname}</h5>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" onClick={()=>{handleReset(`#${modalId}`);}} aria-label="Close"></button>
        </div>
        <div className="offcanvas-body" style={{ paddingBottom: '80px' }}>

<div className='d-flex'>

<div style={{position:'relative',marginBottom:'50px',width:'75%'}}>

<form id={formId} encType="multipart/form-data" className='order-2'>
  
<div className={`form-step ${currentStep === 1 ? "active" : ""}`} data-step="1">

           <div className="row g-3">
                
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="vendor_name" className="form-label">Vendor Name<span className='text-danger'>*</span></label>
                  <input id="vendor_name" name="vendor_name" type="text" className="form-control" placeholder="Vendor Name" required />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="vtype" className="form-label">Vendor Type</label>
                  <input id="vtype" name="vtype" type="text" className="form-control" placeholder="Vendor Type" />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="lead" className="form-label">Engagement Lead</label>
                  <input id="lead" name="lead" type="text" className="form-control" placeholder="Engagement Lead"/>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="placementType" className="form-label">Business Type</label>
                  <Select
                    options={placementType || []}
                    value={(placementType || []).find(opt => opt.value === selectPlace) || null}
                    onChange={(option) => setPlacement(option ? option.value : null)}
                    placeholder="Select Type"
                  />
                </div>
                  <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="costCenter" className="form-label">COST CENTER</label>
                  <Select
                    options={costCenterOptions || []}   // must be an array
                    value={(costCenterOptions || []).find(opt => opt.value == selectedCost) || null}
                    onChange={(option) => setCost(option ? option.value : null)}
                    placeholder="Select Center"
                  />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6" >
                  <label className="form-label" htmlFor="vendor_category"><span className='text-danger fs-15'>*</span>Vendor Category</label>

                  <Select
                    options={GenderOptions}   // must be an array
                    value={GenderOptions.find(opt => opt.value == selectedGender) || null}
                    onChange={(option) => setGender(option ? option.value : null)}
                    placeholder="Select Category"
                  />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6" >
                  <label className="form-label" htmlFor="vendor_status"><span className='text-danger fs-15'>*</span>Status</label>

                  <Select
                    options={StatusOption}   // must be an array
                    value={StatusOption.find(opt => opt.value == selectedStatus) || null}
                    onChange={(option) => setStatus(option ? option.value : null)}
                  />
                </div>

                <div className="col-xl-8 col-lg-8 col-md-12">
                  <label className="form-label">
                    Service Categories<span className='text-danger fs-15'>*</span>
                  </label>
                  <Select
                    options={categoryOptions}
                    isMulti
                    closeMenuOnSelect={false}
                    value={selectedCategoryOptions}
                    onChange={(options) => setSelectedServiceCategories(options.map(opt => opt.value))}
                    placeholder="Select Categories"
                  />
                  <small className="text-muted">Minimum 1 category required.</small>
                </div>

                

                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="manager" className="form-label">Manager</label>
                  <input id="manager" name="manager" type="text" className="form-control" placeholder="Manager" />
                </div>
                
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="state" className="form-label">STATE</label>
                  <input id="state" name="state" type="text" className="form-control" placeholder="State" />
                </div>

              <div className="col-lg-6 col-md-6 col-sm-6">
                  <label htmlFor="address" className="form-label">Address</label>
                  <textarea placeholder='Address' id='address' name='address' className='form-control' rows={4}></textarea>
                </div>

                 <div className="col-lg-6 col-md-6 col-sm-6">
                       <div className='row'>
  
                 <div className="col-xl-12 col-lg-12 col-md-12">
                  <label htmlFor="city" className="form-label">City</label>
                  <input id="city" name="city" type="text" className="form-control" placeholder="City" />
                </div>
              
                
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <label htmlFor="pincode" className="form-label">PINCODE</label>
                  <input id="pincode" name="pincode" type="text" className="form-control" placeholder="Pincode" />
                </div>
          
                       </div>
                  </div>
            
              </div>
         
</div>

<div className={`form-step ${currentStep === 2 ? "active" : ""}`} data-step="2">

  <div className="row g-3">
                <div className="col-xl-6 col-lg-6 col-md-6">
                  <label htmlFor="placementType" className="form-label">Salutation</label>
                  <Select
                    options={saluationType || []}
                    value={(saluationType || []).find(opt => opt.value === selectSalu) || null}
                    onChange={(option) => setSalutation(option ? option.value : null)}
                    placeholder="Select Salutation"
                  />
                </div>
              <div className="col-xl-6 col-lg-6 col-md-6">
                  <label htmlFor="firstname" className="form-label">First Name</label>
                  <input id="firstname" name="firstname" type="text" className="form-control" placeholder="First Name" />
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6">
                  <label htmlFor="lastname" className="form-label">Last Name</label>
                  <input id="lastname" name="lastname" type="text" className="form-control" placeholder="Last Name" />
                </div>
                 <div className="col-xl-6 col-lg-6 col-md-6">
                  <label htmlFor="costCenter" className="form-label">Category Type</label>
                  <Select
                    options={CategoryType || []}   // must be an array
                    value={(CategoryType || []).find(opt => opt.value == selectCategory) || null}
                    onChange={(option) => setCategory(option ? option.value : null)}
                    placeholder="Select Category"
                  />
                </div>

               <div className="col-xl-6 col-lg-6 col-md-6">
                  <label htmlFor="email" className="form-label">Email<span className='text-danger'>*</span></label>
                  <input id="email" name="email" type="email" className="form-control" placeholder="Email Address" required/>
                </div>
               
                 
                
               <div className="col-xl-6 col-lg-6 col-md-6">
                  <label htmlFor="mobile" className="form-label">Mobile No.<span className='text-danger'>*</span></label>
                  <input
                    id="mobile"
                    name="mobile"
                    type="text"
                    className="form-control"
                    placeholder="Mobile no."
                    inputMode="numeric"
                    maxLength={10}
                    minLength={10}
                    pattern="\d{10}"
                    onChange={(e) => {
                      e.target.value = e.target.value.replace(/\D/g, "").slice(0, 10);
                    }}
                    required
                  />
                </div>
              

</div>
         

 </div>
<div className={`form-step ${currentStep === 3 ? "active" : ""}`} data-step="3">
  
<div className="row g-3">
       <div className="col-xl-6 col-lg-6 col-md-6">
                  <label htmlFor="costCenter" className="form-label">Profile</label>
                  <Select
                    options={ProfileType || []}   // must be an array
                    isMulti
                    closeMenuOnSelect={false}
                    value={ProfileType.filter(opt => selectProfile.includes(opt.value))}
                    onChange={(options) => setProfile(options.map(opt => opt.value))}
                    placeholder="Select Profile"
                  />
                </div>
                
                <div className="col-xl-6 col-lg-6 col-md-6">
                  <label htmlFor="location" className="form-label"><span className='text-danger'>*</span>Location</label>
                   <Select
                    options={LocationType || []}   // must be an array
                    isMulti
                    closeMenuOnSelect={false}
                    value={LocationType.filter(opt => selectLocation.includes(opt.value))}
                    onChange={(options) => setLocation(options.map(opt => opt.value))}
                    placeholder="Select Locations"
                  />
                  <input
                    type="text"
                    name="location_required"
                    value={selectLocation.join(",")}
                    required
                    readOnly
                    style={{ display: "none" }}
                  />
                </div>
               
                 
                <div className="col-xl-6 col-lg-6 col-md-6">
                  <label htmlFor="education" className="form-label"><span className='text-danger'>*</span>Education</label>
                  <Select
                    options={EducationType || []}   // must be an array
                    isMulti
                    closeMenuOnSelect={false}
                    value={EducationType.filter(opt => selectEducation.includes(opt.value))}
                    onChange={(options) => setEducation(options.map(opt => opt.value))}
                    placeholder="Select Educations"
                  />
                  <input
                    type="text"
                    name="education_required"
                    value={selectEducation.join(",")}
                    required
                    readOnly
                    style={{ display: "none" }}
                  />
                </div>

                <div className="col-xl-6 col-lg-6 col-md-6">
                  <label htmlFor="skill" className="form-label"><span className='text-danger'>*</span>Skills</label>
                   <Select
                    options={skillType || []}   // must be an array
                    isMulti
                    closeMenuOnSelect={false}
                    value={skillType.filter(opt => selectSkills.includes(opt.value))}
                    onChange={(options) => setSkill(options.map(opt => opt.value))}
                    placeholder="Select Skilss"
                  />
                  <input
                    type="text"
                    name="skills_required"
                    value={selectSkills.join(",")}
                    required
                    readOnly
                    style={{ display: "none" }}
                  />
                </div>
              
</div>

 </div>

 <div className={`form-step ${currentStep === 4 ? "active" : ""}`} data-step="4">
  <div className="row g-3">
  <div className="col-xl-4 col-lg-4 col-md-6">
    <label htmlFor="gstNo" className="form-label">GST NO</label>
    <input id="gstNo" name="gstNo" type="text" className="form-control" placeholder="Gst No" />
  </div>

  <div className="col-xl-4 col-lg-4 col-md-6">
    <label htmlFor="panNo" className="form-label">PAN NO</label>
    <input id="panNo" name="panNo" type="text" className="form-control" placeholder="Pan No" />
  </div>

  <div className="col-xl-4 col-lg-4 col-md-6">
    <label htmlFor="invoiceCountry" className="form-label">INVOICE COUNTRY</label>
    <input id="invoiceCountry" name="invoiceCountry" type="text" className="form-control" placeholder="Invoice Country" />
  </div>

  <div className="col-xl-4 col-lg-4 col-md-6">
    <label htmlFor="invoiceState" className="form-label">INVOICE STATE</label>
    <input id="invoiceState" name="invoiceState" type="text" className="form-control" placeholder="Invoice State" />
  </div>

  <div className="col-xl-4 col-lg-4 col-md-6">
    <label htmlFor="serviceTaxNo" className="form-label">SERVICE TAX NO</label>
    <input id="serviceTaxNo" name="serviceTaxNo" type="text" className="form-control" placeholder="Service Tax No" />
  </div>

  <div className="col-xl-4 col-lg-4 col-md-6">
    <label htmlFor="tanNo" className="form-label">TAN NO</label>
    <input id="tanNo" name="tanNo" type="text" className="form-control" placeholder="Tan No" />
  </div>

  <div className="col-xl-4 col-lg-4 col-md-6">
    <label htmlFor="taxType" className="form-label">TAX TYPE</label>
    <Select
                    options={TaxOptions || []}
                    value={(TaxOptions || []).find(opt => opt.value === selectTax) || null}
                    onChange={(option) => setTax(option ? option.value : null)}
                    placeholder="Select Type"
                  />
  </div>

  <div className="col-xl-4 col-lg-4 col-md-6">
    <label htmlFor="shipToName" className="form-label">SHIP TO NAME</label>
    <input id="shipToName" name="shipToName" type="text" className="form-control" placeholder="Ship To Name" />
  </div>

  <div className="col-xl-4 col-lg-4 col-md-6">
    <label htmlFor="shipToAddress" className="form-label">SHIP TO ADDRESS</label>
    <input id="shipToAddress" name="shipToAddress" type="text" className="form-control" placeholder="Ship To Address" />
  </div>

  <div className="col-xl-4 col-lg-4 col-md-6">
    <label htmlFor="shipToPincode" className="form-label">SHIP TO PINCODE</label>
    <input id="shipToPincode" name="shipToPincode" type="text" className="form-control" placeholder="Ship To Pincode" />
  </div>

  <div className="col-xl-4 col-lg-4 col-md-6">
    <label htmlFor="shipToGstNo" className="form-label">SHIP TO GST NO</label>
    <input id="shipToGstNo" name="shipToGstNo" type="text" className="form-control" placeholder="Ship To GST NO" />
  </div>

  <div className="col-xl-4 col-lg-4 col-md-6">
    <label htmlFor="gstType" className="form-label">GST TYPE</label>
                 <Select
                    options={GSTOptions || []}
                    value={(GSTOptions || []).find(opt => opt.value === selectGST) || null}
                    onChange={(option) => setGST(option ? option.value : null)}
                    placeholder="Select Type"
                  />
  </div>

  <div className="col-xl-4 col-lg-4 col-md-6">
    <label htmlFor="salesAnchor" className="form-label">SALES ANCHOR</label>
    <input id="salesAnchor" name="salesAnchor" type="text" className="form-control" placeholder="Sales Anchor" />
  </div>

  <div className="col-xl-8 col-lg-8 col-md-6">
    <label htmlFor="bgvVendor" className="form-label">MARK AS BGV VENDOR</label>
   <Select
                    options={BGoptions || []}
                    value={(BGoptions || []).find(opt => opt.value === selectBG) || null}
                    onChange={(option) => setBG(option ? option.value : null)}
                    placeholder="Select Mark"
                  />
  </div>
   <div className="col-xl-4 col-lg-4 col-md-6">
    <label htmlFor="account" className="form-label">ACCOUNT NUMBER</label>
    <input id="account" name="account" type="text" className="form-control" placeholder="Account Number" />
  </div>
  <div className="col-xl-4 col-lg-4 col-md-6">
    <label htmlFor="bank" className="form-label">Select Bank</label>
   <Select
                    options={BankOptions || []}
                    value={(BankOptions || []).find(opt => opt.value === selectBank) || null}
                    onChange={(option) => setBank(option ? option.value : null)}
                    placeholder="Select Bank"
                  />
  </div>
   <div className="col-xl-4 col-lg-4 col-md-6">
    <label htmlFor="ifsc" className="form-label">IFSC CODE</label>
    <input id="ifsc" name="ifsc" type="text" className="form-control" placeholder="Enter IFSC Code" />
  </div>
</div>

 </div>

<input type="hidden" name="hidden" id="hiddenss" />

</form>

 </div>

<div className="wizard-footer">
    {currentStep > 1 && (
        <button type="button" onClick={handlePrev} className="btn prev-btn">
            BACK
        </button>
    )}
    {currentStep < totalSteps && (
        <button type="button" onClick={handleNext} className="btn next-btn">
            NEXT
        </button>
    )}
    {currentStep === totalSteps && (
        <button type="submit" onClick={FormSubmit} id="initiateBtn" className="btn next-btn">
            Initiate
        </button>
    )}
</div>

       <img className="order-2" src={process.env.PUBLIC_URL + "/admin_assets/images/media/vendor.svg"} style={{ width: '25%', height: '100%' }} />

</div>    
      

        </div>

      </div>

      {!embedOnly && (
      <div className="main-content app-content">

        <div className="container-fluid">

  <div className="row">

<div class="col-xl-12 mt-4">
    <div class="card custom-card">
        <div class="card-header"><div class="card-title">Vendor Summary</div></div>
        <div class="card-body">
            <div class="row gy-md-0 gy-3" style={{gap:'15px 60px'}}>

 {stats.map((item, index) => (
 
 <div class="col-xxl-2 col-xl-2 col-lg-4 col-md-4 col-sm-12" key={index}>
                    <div class="d-flex align-items-top">
                        <div class="me-3">
                            <span class={"avatar avatar-rounded text-white"} style={{backgroundColor:item.color}}>
                                <i class={`${item.icon} fs-28`}></i>
                            </span>
                        </div>
                        <div>
                            <span class="d-block mb-1 text-muted">{item.label}</span>
                            <h6 class="fw-semibold mb-0">{item.count}</h6>
                        </div>
                    </div>
                </div>

  ))}

            </div>
        </div>
    </div>
</div>

</div>

  <div className="row">
              <div className="col-xxl-12 col-xl-12 ">
                <div className="card custom-card">
                  <div className="card-header justify-content-between" style={{ paddingBottom: '15px', alignItems: 'normal' }}>
                    <div>
                      <h6 className="fs-16">{metaData.appname}</h6>
                    </div>
                    <div className="d-flex mt-sm-0 mt-2 align-items-center">
  
                      <div className="input-group" >
                        <input type="search" className="form-control" placeholder="Search VENDOR" id="search-member"  value={globalFilterText}  onChange={(e) => setGlobalFilterText(e.target.value)} />
                      </div>  

                      <button
                        className="btn btn-outline-primary btn-sm ms-2"
                        data-bs-toggle="modal"
                        data-bs-target="#categoryModal"
                      >
                        Add Category
                      </button>

                       {(metaData.typess?.toUpperCase() === "ADMIN" || metaData.add === 1) && (
                          <button className="btn btn-primary btn-sm" onClick={()=>{setCurrentPage(1);}} data-bs-toggle="offcanvas" data-bs-target={`#${modalId}`} id={addButtonId}><i className="ri-add-line fs-18" data-tooltip-content="Add Vendor" data-tooltip-id='global-tooltip' data-tooltip-place='left'></i></button>
                        )}
          
                    </div>
  
                  </div>
                  <div className="card-body" style={{ padding: '0px' }}>
  
             <TableContainer sx={{ maxHeight: '700px'}}>
                            <Table stickyHeader aria-label="requirement tracker table">
                                
                                <TableHead>
                                    <TableRow>
                                        {columns.map((column) => (
                                            <TableCell
                                                key={column.accessorKey}
                                                sx={{ 
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    p: 2.5,
                                                    fontSize: '0.85rem', 
                                                    verticalAlign: 'top',
                                                }}>
                                                <ColumnHeaderWithFilter
                                                    column={column}
                                                    orderBySelector={orderBySelector}
                                                    order={order}
                                                    handleRequestSort={handleRequestSort}
                                                    columnFilters={columnFilters}
                                                    setColumnFilters={setColumnFilters}
                                                />
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
            <TableBody>
    {processedData.map((row, index) => (
       <TableRow key={index} >
            {columns.map((column) => {
                let cellContent = 'N/A'; // Default content
                const cellWidth = column.size ? column.size : 150;
                
                const smStatus = row.statues2?.toLowerCase();    // Your prompt's 'statues2'
                const vendorStatus = row.vtatues2?.toLowerCase(); // Your prompt's 'vtatues2'
                const founderStatus = row.ftatues2?.toLowerCase(); // Your prompt's 'ftatues2'
                const bd = String(metaData.bd); // Get bd inside the map
                
                switch (column.accessorKey) {
                    case 'sm_status_col':
                        if (smStatus === 'success') {
                            cellContent = <span className="badge bg-success fs-13" style={{fontWeight:'100'}}>Approved</span>;
                        } else if (smStatus === 'pending') {
                            cellContent = <span className="badge bg-warning fs-13" style={{fontWeight:'100'}}>Pending</span>;
                        } else if (smStatus === 'decline') {
                            cellContent = <span className="badge bg-danger fs-13" style={{fontWeight:'100'}}>Rejected</span>;
                        }
                        break;
                    case 'vendor_status_col':
                        if (vendorStatus === 'success' && smStatus=='success') {
                            cellContent = <span className="badge bg-success fs-13" style={{fontWeight:'100'}}>Approved</span>;
                        } else if (vendorStatus === 'pending') {
                            cellContent = <span className="badge bg-warning fs-13" style={{fontWeight:'100'}}>Pending</span>;
                        } else if (vendorStatus === 'success' && smStatus=='pending') {
                            cellContent = <span className="badge bg-danger fs-13" style={{fontWeight:'100'}}>Modified</span>;
                        }
                        break;
                    case 'founder_status_col':
                        if (founderStatus === 'success') {
                            cellContent = <span className="badge bg-success fs-13" style={{fontWeight:'100'}}>Approved</span>;
                        } else if (founderStatus === 'pending') {
                            cellContent = <span className="badge bg-warning fs-13" style={{fontWeight:'100'}}>Pending</span>;
                        } else if (founderStatus === 'decline') {
                            cellContent = <span className="badge bg-danger fs-13" style={{fontWeight:'100'}}>Rejected</span>;
                        }
                        break;
                        
                    case 'action_payment_terms':
                        const ActionButton = (text,idd) => (
                            <button
                                className="btn btn-sm btn-primary" 
                                onClick={() => updateDetails(row.hidden, idd)}
                            >
                                {text}
                            </button>
                        );

                        if (bd === '2') {
                            // BD 2 (SM/Requester)
                            if (smStatus === 'pending' && vendorStatus === 'pending') {
                                cellContent = ActionButton("FILL PAYMENT TERMS",1);
                            } else if (vendorStatus === 'success' && smStatus === 'pending') {
                                cellContent = ActionButton("TAKE ACTION",3);
                            } else if (founderStatus === 'pending') {
                                cellContent = <span className="badge bg-warning fs-13" style={{fontWeight:'100'}}>In-processing</span>;
                            } else {
                                cellContent = <span className="badge bg-info fs-13" style={{fontWeight:'100'}}>Approved</span> // Fallback text
                            }
                        } else if (bd === '4') {
                            // BD 4 (Vendor)
                            if (vendorStatus === 'pending' && smStatus === 'success') {
                                cellContent = ActionButton("TAKE ACTION",2);
                            } else if (smStatus === 'pending' && vendorStatus === 'success') {
                                cellContent = <span className="badge bg-warning fs-13" style={{fontWeight:'100'}}>SM Status in Processing</span>;
                            } else if (founderStatus === 'pending') {
                                cellContent = <span className="badge bg-warning fs-13" style={{fontWeight:'100'}}>In-processing</span>;
                            } else {
                                 cellContent = <span className="badge bg-info fs-13" style={{fontWeight:'100'}}>Approved</span>
                            }
                        } else if (bd === '5') {
                            if (vendorStatus === 'success' && smStatus === 'success' && founderStatus=='pending') {
                                cellContent = ActionButton("TAKE ACTION",3);
                            } else if(vendorStatus==='success' && smStatus==='success' && founderStatus==='success'){
                                   cellContent = <span className="badge bg-success fs-13" style={{fontWeight:'100'}}>Approved</span>
                            }
                            else {
                                 cellContent = <span className="badge bg-danger fs-13" style={{fontWeight:'100'}}>In-processing</span>
                            }
                        } else {
                            cellContent = 'N/A'; 
                        }
                        break;
                        
                    default:
                        const value = column.selector ? column.selector(row) : null;
                        cellContent = value;
                        break;
                }

                return (
                    <TableCell 
                        key={column.accessorKey}
                        sx={{ p: 1.5, fontSize: '0.875rem', minWidth: cellWidth, width: cellWidth }}
                    >
                        {cellContent}
                    </TableCell>
                );
            })}
        </TableRow>
    ))}
    
    {/* Empty state if no data */}
    {processedData.length === 0 && (
        <TableRow>
            <TableCell colSpan={columns.length} align="center" sx={{ py: 4 }}>
                <Typography color="textSecondary" variant="body1">
                    No matching found in the current filters.
                </Typography>
            </TableCell>
        </TableRow>
    )}
</TableBody>   

                        </Table>
                        </TableContainer>
            
                  </div>
                    <div className="card-footer d-flex align-items-center justify-content-between" style={{ padding: '10px 25px' }}>
    <p className="text-muted mb-0">
        Showing <strong>{((currentPage - 1) * limit) + 1}</strong> – <strong>{Math.min(currentPage * limit, totalRows)}</strong> of <strong>{totalRows}</strong> entries
    </p>

    <nav aria-label="Page navigation">
        <ul className="pagination mb-0">
            {/* First Page */}
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(1)}>« First</button>
            </li>

            {/* Previous */}
            <li className={`page-item ${currentPage <= 1 ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(prev => prev - 1)}>&laquo;</button>
            </li>

            {/* Dynamic Page Numbers */}
            {pages.map(pageNum => (
                <li key={pageNum} className={`page-item ${currentPage === pageNum ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(pageNum)}>
                        {pageNum}
                    </button>
                </li>
            ))}

            {/* Next */}
            <li className={`page-item ${currentPage >= maxPage ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(prev => prev + 1)}>&raquo;</button>
            </li>

            {/* Last Page */}
            <li className={`page-item ${currentPage === maxPage ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(maxPage)}>Last »</button>
            </li>
        </ul>
    </nav>
                </div>
                </div>
  
              </div>
            </div>
  

        </div>
      </div>
      )}
    </>
  );
}
export default VendorCopy;
